import { createContext, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('token'));
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded = jwtDecode(token);
  
        // Optional: check if token is expired
        if (decoded.exp && decoded.exp * 1000 < Date.now()) {
          console.warn("Token expired");
          logout();
        } else {
          setIsAuthenticated(true);
          setUserRole(decoded.role);
        }
      } catch (error) {
        console.error("Invalid token");
        logout();
      }
    } else {
      setIsAuthenticated(false);
      setUserRole(null);
    }
  }, []);
  

  const login = (token) => {
    localStorage.setItem('token', token);
    setIsAuthenticated(true);
    try {
      const decoded = jwtDecode(token);
      setUserRole(decoded.role);
    } catch (error) {
      console.error("Failed to decode token");
      setUserRole(null);
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setIsAuthenticated(false);
    setUserRole(null);
  };

  const isAdmin = () => userRole === 'admin';
  const isBlog = () => userRole === 'blog';
  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, isAdmin, isBlog, userRole }}>
      {children}
    </AuthContext.Provider>
  );
};
